import React from 'react';

import { FlyThemeColor, getFlyToRadixColor } from '@fly/core';
import { Theme } from '@radix-ui/themes';
import cn from 'classnames';

type BlinkerSize = '1' | '2' | '3';

const sizeMap: Record<BlinkerSize, string> = {
  '1': 'h-1.5 w-1.5',
  '2': 'h-2 w-2',
  '3': 'h-3 w-3',
};

export interface FlyBlinkerProps {
  color?: FlyThemeColor;
  size?: BlinkerSize;
  className?: string;
  ref?: React.Ref<HTMLDivElement>;
}

export function FlyBlinker({
  color = 'success',
  size = '2',
  className,
  ref,
}: FlyBlinkerProps) {
  const radixColor = getFlyToRadixColor(color);

  return (
    <Theme accentColor={radixColor} className='flex'>
      <div ref={ref} className={cn('inline-flex', className)}>
        <div
          className={cn(
            'relative flex items-center justify-center',
            sizeMap[size]
          )}
        >
          <div className={cn('bg-accent-5 h-full w-full rounded-full')} />
          <div
            className={cn(
              'inset-0 border-accent-5 absolute animate-blinker-ring rounded-full border-[0.5px]'
            )}
          />
        </div>
      </div>
    </Theme>
  );
}
